import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './StatsAndServices.css';
import StatCounter from './StatCounter';

const publicUrl = process.env.PUBLIC_URL || '';
const serviceImages = [
  `${publicUrl}/images/feasibility.jpg`,
  `${publicUrl}/images/contracts.jpg`,
  `${publicUrl}/images/program.jpg`,
  `${publicUrl}/images/developing.jpg`,
];

const StatsAndServices = () => {
  const [hasAnimated, setHasAnimated] = useState(false);
  const statsRef = useRef(null);

  useEffect(() => {
    const element = statsRef.current;
    if (!element || hasAnimated) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setHasAnimated(true);
            observer.disconnect();
          }
        });
      },
      {
        threshold: 0.2,
      }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [hasAnimated]);

  const services = [
    { id: 'feasibility', title: 'Feasibility & Bidding Management', description: 'Building, supporting, monitoring and reviewing feasibility stages (market, technical, financial). Managing primary schedules, bid terms, tender reviews, and technical evaluations.', backgroundImage: serviceImages[0] },
    { id: 'contracts', title: 'Contracts & Claims Management', description: 'Preparing contracting/subcontracting documents, liability identification, damage calculation, and resolving claims through negotiation or arbitration.', backgroundImage: serviceImages[1] },
    { id: 'management', title: 'Program & Project Management', description: 'Developing schedules, manpower plans, and cash flows. Monitoring progress, design review, risk management, and providing regular performance reports.', backgroundImage: serviceImages[2] },
    { id: 'capabilities', title: 'Developing PM Capabilities', description: 'Providing training in project management, human skills, and leadership. Outsourcing, remote services, and enhancing corporate PMOs.', backgroundImage: serviceImages[3] },
  ];

  return (
    <section className="stats-services-wrapper">
      <div className="stats-container" ref={statsRef}>
        <div className="stat-item">
          <h2 className="stat-number">
            <StatCounter target="25+" duration={2000} start={hasAnimated} />
          </h2>
          <p className="stat-label">Years of Experience</p>
        </div>
        <div className="stat-divider"></div>
        <div className="stat-item">
          <h2 className="stat-number">
            <StatCounter target="500+" duration={2000} start={hasAnimated} />
          </h2>
          <p className="stat-label">Projects Completed</p>
        </div>
        <div className="stat-divider"></div>
        <div className="stat-item">
          <h2 className="stat-number">
            <StatCounter target="100%" duration={2000} start={hasAnimated} />
          </h2>
          <p className="stat-label">Client Satisfaction</p>
        </div>
      </div>

      <div className="services-grid-container">
        <div className="services-header">
          <h2 className="services-main-title">Our Services</h2>
          <p className="services-intro">
            MTPRO services are not limited to any specific industry, and are provided to a broad range of clients in different sectors, including, among others, Property management, Information Technology, Telecommunications, Real Estate, Construction, Infrastructure, Banking, Finance, Government, Renewable Energy, Oil and Gas.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div
              key={index}
              className="service-card service-card--bg card"
              style={{ backgroundImage: `url(${service.backgroundImage})` }}
            >
              <div className="service-card-overlay" />
              <div className="service-card-content">
                <h4 className="service-card-title">{service.title}</h4>
                <p className="service-card-desc">{service.description}</p>
                <Link to={`/services/${service.id}`} className="service-btn">Learn More</Link>
              </div>
            </div>
          ))}
        </div>

        <div className="services-footer">
          <Link to="/services" className="btn-more-services">More services</Link>
        </div>
      </div>
    </section>
  );
};

export default StatsAndServices;
